import React, { useState } from 'react';
import './Login.css';

const Login = ({ onLogin }) => {
  const [isSignup, setIsSignup] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    companyName: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const endpoint = isSignup ? '/api/auth/signup' : '/api/auth/login';
      const body = isSignup
        ? { name: formData.name, email: formData.email, password: formData.password, companyName: formData.companyName, role: 'Admin' }
        : { email: formData.email, password: formData.password };

      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });

      const data = await response.json();

      if (response.ok) {
        onLogin(data.token, data.user);
      } else {
        setError(data.detail || 'Authentication failed');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1 className="login-title">AA Project Management</h1>
          <p className="login-subtitle">Project Management System</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {isSignup && (
            <>
              <div className="form-group">
                <label className="form-label">Your Name</label>
                <input
                  type="text"
                  className="input"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required={isSignup}
                  placeholder="John Doe"
                  data-testid="signup-name-input"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Company/Organization Name</label>
                <input
                  type="text"
                  className="input"
                  value={formData.companyName}
                  onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
                  required={isSignup}
                  placeholder="e.g., Smith Architecture Firm"
                  data-testid="signup-company-input"
                />
                <p className="form-helper">Your workspace name</p>
              </div>
            </>
          )}

          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="input"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
              data-testid="login-email-input"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="input"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
              data-testid="login-password-input"
            />
          </div>

          {error && <div className="form-error">{error}</div>}

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            data-testid="login-submit-button"
            style={{ width: '100%', marginTop: '16px' }}
          >
            {loading ? 'Please wait...' : isSignup ? 'Sign Up' : 'Log In'}
          </button>
          
          {!isSignup && (
            <div style={{ textAlign: 'center', marginTop: '12px' }}>
              <a 
                href="#" 
                onClick={(e) => {
                  e.preventDefault();
                  alert('Password reset: Please contact your administrator or use the password reset email sent to you.');
                }}
                style={{ color: 'var(--monday-blue)', fontSize: '14px', textDecoration: 'none' }}
              >
                Forgot Password?
              </a>
            </div>
          )}
        </form>

        <div className="login-footer">
          <button
            type="button"
            className="login-toggle"
            onClick={() => {
              setIsSignup(!isSignup);
              setError('');
            }}
            data-testid="toggle-auth-mode"
          >
            {isSignup ? 'Already have an account? Log In' : "Don't have an account? Sign Up"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;